export default {
    nodeUrl: 'https://monsternode.net/node',
};
